export default __webpack_public_path__ + "static/media/safet.30a6183f.png";